import React, { PropsWithChildren } from "react";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";
import { LinkText } from "./file-download-text.styles";

export const FileDownloadText = withShowIf((props: PropsWithChildren<any>) => (
  <LinkText onClick={props.onClick}>{props.children}</LinkText>
));
